// removed by extract-text-webpack-plugin
module.exports = {"item":"_2GB8Fpr_J8CCmd2sBoNLHA","maxLength":"_3KTH-Gv861eCD8MSKJaNEr","btnMore":"ZqNtCoafBO984R3_LFiXS","formField":"_3kDOynH7hdiSN4F3sEXrW_","required":"_3gS9tHegUH2d8IHGYskC5y","hebrew":"bhgU_jbCiAGUJ3bran6Hk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTextFieldWithOptionsLang/OMTextFieldWithOptionsLang.scss
// module id = 1674
// module chunks = 0